import { Component, Input } from '@angular/core';
import { EMCType } from '../../../../enums/emc-type';
import { EntityModelConfiguration } from '../../../../enums/entityModelConfiguration';
import { EntityModelCustomizationService, SubstationTemplateUICustomizationDto } from 'shared-lib';
import { ToastrService } from 'ngx-toastr';
import { UtilitySharedService } from '../../../../shared/_services/utility-shared.service';

@Component({
  selector: 'app-emc-recall',
  templateUrl: './emc-recall.component.html',
  styleUrl: './emc-recall.component.scss',
  standalone: false
})
export class EmcRecallComponent {
  @Input() entityType: EMCType;
  @Input() substationTemplate: SubstationTemplateUICustomizationDto | null = null;

  EntityModelConfiguration = EntityModelConfiguration;
  EMCConfiguration: EntityModelConfiguration[] = [];
  utilityId: number;

  constructor(private emcService: EntityModelCustomizationService, private toastrService: ToastrService, private utilitySharedService: UtilitySharedService) {
    this.getConfigFromLocalStorage();
    this.utilityId = this.utilitySharedService.getUtilityId()!;
  }

  private getConfigFromLocalStorage() {
    const config = localStorage.getItem('EMCConfiguration');
    this.EMCConfiguration = JSON.parse(config!) as EntityModelConfiguration[];
  }

  private setConfigToLocalStorage() {
    localStorage.removeItem('EMCConfiguration');
    localStorage.setItem('EMCConfiguration', JSON.stringify(this.EMCConfiguration));
    this.EMCConfiguration = JSON.parse(localStorage.getItem('EMCConfiguration')!) as EntityModelConfiguration[];
  }

  isChecked(values: EntityModelConfiguration[]): boolean {
    return values.every(v => this.EMCConfiguration.includes(v));
  }

  onToggleCheckbox(values: EntityModelConfiguration[]) {
    this.getConfigFromLocalStorage();

    values.forEach(value => {
      if (this.EMCConfiguration.includes(value)) {
        this.EMCConfiguration = this.EMCConfiguration.filter(x => x !== value);
      } else {
        this.EMCConfiguration = [...this.EMCConfiguration, value];
      }
    });

    this.EMCConfiguration.sort((a, b) => a - b);
    this.setConfigToLocalStorage();
    this.saveConfiguration();
  }

  private saveConfiguration() {
    var obj = {
      type: this.entityType,
      utilityId: this.utilityId,
      configuration: this.EMCConfiguration,
      substationTemplateId: this.substationTemplate ? this.substationTemplate.id! : undefined
    }
    this.emcService.saveConfiguration(obj).subscribe({
      next: (response: any) => {
        if (response.body.status == 200 || response.body.status == 'OK')
          this.toastrService.success('Configuration updated successfully.')
        else 
          this.toastrService.error('Configuration failed to update.')
      }
    })
  }
}
